import { render } from "./Details.vue?vue&type=template&id=fc3c3870&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=fc3c3870&scoped=true&lang=css"

import exportComponent from "/var/www/html/tsk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc3c3870"]])

export default __exports__